import Footer from '@/components/layout/footer';
import { NavbarConsumer } from '@/components/layout/navbar/navbar.consumer';
import ConsumerSidebar from '@/components/layout/sidebar/sidebar.consumer';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_authenticated')({
  beforeLoad: ({ context, location }) => {
    // Check if user is authenticated
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }

    // Check if user has the correct role for consumer routes
    if (context.auth.user?.role !== 'customer') {
      throw redirect({
        to: '/cleaner/dashboard',
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div>
      <NavbarConsumer />
      <div className="max-w-7xl mx-auto px-4 py-6 mt-[50px] md:mt-[140px]">
        <div className="flex flex-col md:flex-row gap-0 md:gap-8">
          <div>
            <ConsumerSidebar />
          </div>
          <div className="w-full">
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
